import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class IshodNastavneJedinicePopisService {

  constructor(private _http: Http) { }

  dohvati_sve_ishode_nastavnih_jedinica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_sve_ishode_nastavnih_jedinica', a)
    .map(res => res.json());
  }

  obrisi_ishode_nastavnih_jedinica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'obrisi_ishode_nastavnih_jedinica', a)
    .map(res => res.json());
  }

  spremi_ishode_nastavnih_jedinica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'spremi_ishode_nastavnih_jedinica', a)
    .map(res => res.json());
  }

  uredi_ishode_nastavnih_jedinica(a: any){
    return this._http.put(AppConfig.apiAdresaSQL + 'uredi_ishode_nastavnih_jedinica', a)
    .map(res => res.json());
  }

  dohvatiAktivnaPodrucjaznanja(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_aktivna_podrucjaznanja', a)
    .map(res => res.json());
  }

  dohvatiAktivneModule(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_aktivne_module', a)
    .map(res => res.json());
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/ishod-nastavnejedinice-popis/ishod-nastavnejedinice-popis.service.ts